import React, { useState, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";

import {
  Box,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Switch,
  Paper,
  Popper,
  ClickAwayListener,
  Divider,
  useTheme,
  alpha,
} from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import SearchIcon from "@mui/icons-material/Search";
import { useDispatch, useSelector } from 'react-redux';
import { updateAppSettingR } from "../../General/Store/GeneralSlice";
import ManageSearchIcon from '@mui/icons-material/ManageSearch';


// رنگ ثابت آبی برای آیکون تنظیمات و سوییچ‌ها
const BLUE = "#1E6AFD";

/**
 * SettingsMenu
 * منوی تنظیمات نرم‌افزار — دراپ‌داون با MUI Popper رندر می‌شود (پورتال به document.body)
 * تا از مشکلات overflow/stacking-context والدها (مثل position:sticky یا overflow:hidden
 * در AppBar) عبور کند و همیشه بالای بقیه‌ی لایه‌ها بمونه.
 *
 * props:
 *  - extraItems: آرایه‌ای اختیاری از آیتم‌های اضافه با ساختار:
 *      { label, action, icon, onSelect, onToggle, defaultEnabled }
 */
export default function SettingsMenu() {
  const appSetting = useSelector(state => state.general.appSetting);
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const theme = useTheme();
  const dispatch = useDispatch();


  const handleMenuSearch = () => {
    // TODO: قابلیت جست‌وجوی منو — پیاده‌سازی بعداً
  };

  const menuItems = [
    {
      label: "جست‌وجوی منو",
      action: "menu-search",
      icon: <ManageSearchIcon fontSize="small" />,
      onSelect: handleMenuSearch,
      defaultEnabled: appSetting.mainMenuSeacrh,
      name:'mainMenuSeacrh'
    },
    // {
    //   label: "جست و جو پیشرفته",
    //   action: "advanced-search",
    //   icon: <ManageSearchIcon fontSize="small" />,
    //   onSelect: handleMenuSearch,
    //   defaultEnabled: false,
    //   name:'advancedSeacrh'

    // },
  ];

  const [enabledMap, setEnabledMap] = useState(() =>
    menuItems.reduce((acc, item) => {
      acc[item.action] = !!item.defaultEnabled;
      return acc;
    }, {})
  );

  const handleToggle = (item) => (event) => {
    const checked = event.target.checked;
    const key = item.name;
    let info={
      key,
      checked
    }
    dispatch(updateAppSettingR(info))
    setEnabledMap((prev) => ({ ...prev, [item.action]: checked }));
  };

  const itemVariants = {
    hidden: { opacity: 0, y: -5 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
      <IconButton
        ref={anchorRef}
        onClick={() => setOpen((prev) => !prev)}
        sx={{
          color: open ? BLUE : "text.secondary",
          bgcolor: open ? alpha(BLUE, theme.palette.action.selectedOpacity) : "transparent",
          "&:hover": { bgcolor: alpha(BLUE, theme.palette.action.hoverOpacity) },
          transition: theme.transitions.create(["background-color", "color"]),
        }}
      >
        <motion.div
          animate={{ rotate: open ? 180 : 0 }}
          transition={{ duration: 0.3, ease: "easeInOut" }}
          style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
        >
          <SettingsIcon sx={{ color: open ? BLUE : "inherit" }} />
        </motion.div>
      </IconButton>

      <Popper
        open={open}
        anchorEl={anchorRef.current}
        placement="bottom-end"
        // بالاتر از modal تا هیچ لایه‌ی دیگه‌ای (منوی ماژول، مودال‌ها و ...) روش ننشینه
        sx={{ zIndex: theme.zIndex.modal + 10 }}
        modifiers={[{ name: "offset", options: { offset: [0, 8] } }]}
      >
        <ClickAwayListener onClickAway={() => setOpen(false)}>
          <AnimatePresence>
            {open && (
              <motion.div
                initial={{ opacity: 0, y: -8 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -8 }}
                transition={{ duration: 0.2, ease: "easeInOut" }}
              >
                <Paper elevation={3} sx={{ borderRadius: 2, minWidth: 240, overflow: "hidden" }}>
                  <List disablePadding dense>
                    {menuItems.map((item, index) => (
                      <React.Fragment key={item.action + index}>
                        <motion.div variants={itemVariants} initial="hidden" animate="visible">
                          <ListItem
                            secondaryAction={
                              <Switch
                                edge="end"
                                size="small"
                                checked={!!enabledMap[item.action]}
                                onChange={handleToggle(item)}
                                name={menuItems.name}
                                sx={{
                                  "& .MuiSwitch-switchBase.Mui-checked": { color: BLUE },
                                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                                    backgroundColor: BLUE,
                                  },
                                }}
                              />
                            }
                            sx={{
                              cursor: item.onSelect ? "pointer" : "default",
                              "&:hover": { bgcolor: "action.hover" },
                            }}
                            onClick={item.onSelect}
                          >
                            <ListItemIcon sx={{ minWidth: 36, color: BLUE }}>
                              {item.icon}
                            </ListItemIcon>
                            <ListItemText
                              primary={item.label}
                              primaryTypographyProps={{ variant: "body2" }}
                            />
                          </ListItem>
                        </motion.div>
                        {index < menuItems.length - 1 && <Divider component="li" />}
                      </React.Fragment>
                    ))}
                  </List>
                </Paper>
              </motion.div>
            )}
          </AnimatePresence>
        </ClickAwayListener>
      </Popper>
    </Box>
  );
}
